import { RequisitionsQueryFilter } from "./requisitions-query-filter.model";
import { RequisitionsInfiniteScrollContainer } from "./requisitions-infinite-scroll-container";
import { requisitionDisplaySelectedFilter } from "./requisition-display-selected-filter.model";
export class RequisitionsPageController {
    /*@ngInject*/
    constructor($rootScope, $state, $timeout, $filter, moment, StorageService, requisitionService, jobService, companyService, stateManagementStorageService, genericService, alertsAndNotificationsService, sharedAjsService, REQUISITIONSCONSTANTS, MESSAGECONSTANTS) {
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$timeout = $timeout;
        this.$filter = $filter;
        this.moment = moment;
        this.StorageService = StorageService;
        this.requisitionService = requisitionService;
        this.jobService = jobService;
        this.companyService = companyService;
        this.stateManagementStorageService = stateManagementStorageService;
        this.genericService = genericService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.sharedAjsService = sharedAjsService;
        this.REQUISITIONSCONSTANTS = REQUISITIONSCONSTANTS;
        this.MESSAGECONSTANTS = MESSAGECONSTANTS;
    }
    $onInit() {
        this.$stateParams = this.$transition$.params();
        this.userId = this.$rootScope.userDetails.id;
        this.companyId = this.$rootScope.userDetails.company.companyId;
        this.companyState = this.$rootScope.userDetails.company.companyState;
        this.companyType = this.$rootScope.userDetails.company.companyType;
        this.isCompanyVendor = this.companyService.isCompanyVendor();
        this.isStaffingCompany = this.companyService.isStaffingCompany();
        this.salaryDurationOptions = [];
        this.count = 2;
        this.queryRequisitions = _.debounce(this.queryRequisitions, 500);
        this.showFiltersPanel = false;
        this.isFiltersChanged = false;
        this.isClient = true;
        this.hideSearchByText = false;
        this.showpopup = false;
        this.reqNumFlag = false;
        this.emptySelectedFilter = false;
        this.isRowViewActive = false;
        this.selectedClients = [];
        this.selectedRequisitionTypes = [];
        this.selectedRoles = [];
        this.selectedStatuses = [];
        this.selectedJobTypes = [];
        this.selectedWorkLocations = [];
        this.selectedRecruiters = [];
        this.selectedSortByList = [];
        this.selectedRequisitionNumbers = [];
        this.requisitionNumbersList = [];
        this.sortByList = [];
        this.requisitionsContainer = null;
        this.savedFilters = null;
        this.savedDisplayedRequisitionSelectedFilter = null;
        this.displayRequisitionFilterItemsSelected = [];
        this.searchTerm = '';
        this.requisitions = [];
        let filter = new RequisitionsQueryFilter(this.companyId);
        if (!_.isNull(this.$stateParams.requisitionStatesArray)) {
            filter.requisitionStates = [];
            angular.forEach(this.$stateParams.requisitionStatesArray, (val, key) => {
                filter.requisitionStates.push(angular.uppercase(val));
            });
        }
        this.selectedDateRange = "";
        this.selectedSort = "Please Select";
        if (this.isStaffingCompany) {
            this.isClient = true;
            this.clientOfBuSortValue = "Client";
        }
        else {
            this.isClient = false;
            this.clientOfBuSortValue = "BU";
        }
        this._getDetailsNeededForRequisitionCards();
        this.requisitionsContainer = new RequisitionsInfiniteScrollContainer(this.userId, this.companyId, this.jobService, this.alertsAndNotificationsService, this.isStaffingCompany);
        this.requisitionsContainer.requisitionsQueryFilter = angular.copy(filter);
        // Remove requisition screen on company switch (in super user)
        this._checkAndRemoveIfFilterExistsWithCompanyId();
        let savedFilters = this.stateManagementStorageService.getScreenState(`requisitionsScreen-${this.userId}`);
        if (savedFilters && filter.requisitionStates.length == 0) {
            this.requisitionsContainer.requisitionsQueryFilter = angular.copy(savedFilters);
            this.savedFilters = angular.copy(savedFilters);
        }
        else {
            this.stateManagementStorageService.setScreenState(`requisitionsScreen-${this.userId}`, filter);
        }
        // Display Selected Filter
        this.displayRequisitionSelectedFilter = new requisitionDisplaySelectedFilter();
        let savedDisplayedRequisitionSelectedFilter = this.stateManagementStorageService.getScreenState(`requisitionsScreen-displayFilter-${this.userId}`);
        if (savedDisplayedRequisitionSelectedFilter) {
            if (!_.isNull(this.$stateParams.requisitionStatesArray)) {
                this.stateManagementStorageService.setScreenState(`requisitionsScreen-displayFilter-${this.userId}`, savedDisplayedRequisitionSelectedFilter);
            }
            this.displayRequisitionSelectedFilter = angular.copy(savedDisplayedRequisitionSelectedFilter);
            // Set Sort By Filter to Null
            this.displayRequisitionSelectedFilter.selectedFilterSort = "";
            this.savedDisplayedRequisitionSelectedFilter = angular.copy(savedDisplayedRequisitionSelectedFilter);
            if (_.isUndefined(this.displayRequisitionSelectedFilter.showDisplayFilterIconFlag)) {
                this.displayRequisitionSelectedFilter.showDisplayFilterIconFlag = true;
            }
        }
        else {
            this.stateManagementStorageService.setScreenState(`requisitionsScreen-displayFilter-${this.userId}`, this.displayRequisitionSelectedFilter);
            this.savedDisplayedRequisitionSelectedFilter = angular.copy(this.displayRequisitionSelectedFilter);
        }
        this.showDisplaySelectedFilterPanel = this.displayRequisitionSelectedFilter.showDisplayFilterIconFlag;
        // If params From Re run scoring
        this.setReRunScoreFilters(filter);
        this._setRequisitionSortByFilter();
        this._getAndSetFilters();
        this._initJquery();
        // this.$timeout(() => {
        //     this.selectedDateRange = '';
        // }, 2000);
        this.currentRequisitionPage = 1;
        this._setRequisitionRowView();
        this.myStyle = "{width: 8%}";
        // If login params exists open documents tab after user login
        if (this.$stateParams.loginParamsObject && this.$stateParams.loginParamsObject.redirect == 'documents') {
            this._openCandidateBookletDocumentsModal();
        }
    }
    setReRunScoreFilters(filter) {
        if (this.$stateParams.userParamsObject && this.$stateParams.userParamsObject.requisitionNumber) {
            // Reset filters
            this.requisitionsContainer.requisitionsQueryFilter = angular.copy(filter);
            this.requisitionsContainer.requisitionsQueryFilter.requisitionNums = [this.$stateParams.userParamsObject.requisitionNumber];
            this.stateManagementStorageService.setScreenState(`requisitionsScreen-${this.userId}`, this.requisitionsContainer.requisitionsQueryFilter);
            this.savedFilters = this.requisitionsContainer.requisitionsQueryFilter;
            // Reset Display Filters
            this.displayRequisitionSelectedFilter = new requisitionDisplaySelectedFilter();
            this.displayRequisitionSelectedFilter.requisitionNums = this.requisitionsContainer.requisitionsQueryFilter.requisitionNums;
            this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
            this.stateManagementStorageService.setScreenState(`requisitionsScreen-displayFilter-${this.userId}`, this.displayRequisitionSelectedFilter);
            this.savedDisplayedRequisitionSelectedFilter = angular.copy(this.displayRequisitionSelectedFilter);
        }
    }
    _openCandidateBookletDocumentsModal() {
        let actionType = 'candidateBooklet';
        let actionLabel = this.$stateParams.loginParamsObject + "'s" + ' Booklet';
        this.sharedAjsService.goToCandidateDocuments(actionType, actionLabel, this.$stateParams.loginParamsObject);
    }
    _setRequisitionRowView() {
        let checkIfRowViewActive = this.stateManagementStorageService.getScreenState(`requisitionsScreen-rowView-${this.userId}`);
        if (checkIfRowViewActive) {
            this.isRowViewActive = checkIfRowViewActive.isRowViewActive;
            if (this.isRowViewActive) {
                this.requisitionsContainer.getNextPage(this.currentRequisitionPage);
            }
        }
    }
    toggleRequisitionRowView() {
        this.isRowViewActive = !this.isRowViewActive;
        this.stateManagementStorageService.setScreenState(`requisitionsScreen-rowView-${this.userId}`, { isRowViewActive: this.isRowViewActive });
        if (this.isRowViewActive) {
            this.requisitionsContainer.getNextPage(this.currentRequisitionPage);
        }
        else {
            this.requisitionsContainer.requisitionsExistFlag = true;
            this.requisitionsContainer.requisitionsQueryFilter.pageNum = 1;
            this.requisitionsContainer.requisitions = [];
            this.requisitionsContainer.disableInfiniteScroll = false;
        }
    }
    _setRequisitionSortByFilter() {
        this.requisitionSortByFilters = [
            {
                "column": "clientorbu",
                "columnDisplayName": this.clientOfBuSortValue
            },
            {
                "column": "title",
                "columnDisplayName": "Role"
            },
            {
                "column": "requisitionState",
                "columnDisplayName": "Requisition Status"
            },
            {
                "column": "requisitionNumber",
                "columnDisplayName": "Requisition Number"
            },
            {
                "column": "updatedDate",
                "columnDisplayName": "Updated Date"
            }
        ];
        if (!_.isNull(this.savedFilters) && this.savedFilters.sortColumn !== "" && this.savedFilters.sortDirection !== "") {
            let savedSortColumn = this.savedFilters.sortColumn + " " + this.savedFilters.sortDirection;
            let savedSelectedSort = this.savedFilters.sortDirection.slice(0, 1) + this.savedFilters.sortDirection.slice(1).toLowerCase();
            let savedSortDirection = "";
            this.requisitionSortByFilters.forEach(filter => {
                if (filter.column == this.savedFilters.sortColumn) {
                    savedSortDirection = filter.columnDisplayName;
                }
            });
            this.sortRequisitions(savedSortColumn, savedSortDirection, savedSelectedSort);
        }
    }
    _checkAndRemoveIfFilterExistsWithCompanyId() {
        let existingRequisitionScreenState = this.stateManagementStorageService.getScreenState(`requisitionsScreen-${this.userId}`);
        if (existingRequisitionScreenState) {
            if (existingRequisitionScreenState.companyId !== this.companyId) {
                this.stateManagementStorageService.clearStateScreen(`requisitionsScreen-${this.userId}`);
                this.stateManagementStorageService.clearStateScreen(`requisitionsScreen-displayFilter-${this.userId}`);
            }
        }
    }
    _getAndSetFilters() {
        this._getClientsOrBus(() => {
            this._getRoles("all");
            this.getRequisitionNumbers("all", () => {
                this._getRecruiters(() => {
                    this._getRequisitionStatusTypes(() => {
                        this._getJobTypes(() => {
                            this._getWorkLocations(() => {
                                this.savedFilters = null;
                            });
                        });
                    });
                });
            });
        });
        this._setRequisitionTypes();
    }
    _getDetailsNeededForRequisitionCards() {
        this._getRequisitionActivityTypes();
        this._getSalaryDurationOptions();
    }
    _getClientsOrBus(successCallback) {
        this.loadingClientsOrBUs = true;
        let requisitionId = null;
        let isFromCreateReq = false;
        this.requisitionService.getAllClientsOrBu(this.$rootScope.userDetails, requisitionId, isFromCreateReq, (data) => {
            this._setClientsOrBus(data);
            this.loadingClientsOrBUs = false;
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            this.loadingClientsOrBUs = false;
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    _setClientsOrBus(clientsOrBus) {
        this.fullClientsList = clientsOrBus;
        angular.forEach(this.fullClientsList, (clientOrBu, key) => {
            if (clientOrBu.companyType == 'Corporation') {
                clientOrBu.name = "<span style='padding-right:5px;'>" + clientOrBu.name + "</span><i class='fas fa-share-alt'></i>";
            }
        });
        this.fullClientsListCopy = angular.copy(this.fullClientsList);
        if (this.savedFilters !== null) {
            this.selectedClients = this.fullClientsList.filter(clientOrBu => this.savedFilters.clientOrBU.some(selectedId => clientOrBu.id == selectedId));
            this.selectedClients.forEach(clientOrBu => clientOrBu.ticked = true);
        }
        if (this.savedDisplayedRequisitionSelectedFilter.clientOrBU.length !== 0 || this.requisitionsContainer.requisitionsQueryFilter.clientOrBU.length !== 0) {
            this.displayRequisitionSelectedFilter.clientOrBU = [];
            this.displayRequisitionSelectedFilter.clientOrBU = this.selectedClients.map((val, index) => {
                if (val.companyType === 'Corporation') {
                    return val.shortName;
                }
                else {
                    return val.name;
                }
            });
            this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
        }
    }
    _getRoles(searchReqText) {
        this.loadingRoles = true;
        this.fullRolesList = [];
        this.selectedRoles = [];
        if (searchReqText == "" || !angular.isDefined(searchReqText)) {
            searchReqText = "all";
        }
        else {
            this.searchReqText = searchReqText;
        }
        let clientOrBuIds = this.selectedClients.map(clientOrBu => clientOrBu.id);
        this.jobService.getRoles(this.userId, this.companyId, this.searchReqText, { clientOrBuIds: clientOrBuIds }, (data) => {
            this._setRoles(data);
            this.loadingRoles = false;
        }, (error) => {
            this.loadingRoles = false;
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    _setRoles(roles) {
        angular.forEach(roles, (val, key) => {
            let roleObj = { "name": val };
            if (!this._containsObject(roleObj, this.fullRolesList, "name")) {
                if (val !== null)
                    roleObj.selectedDisplayName = this.$filter('displayOnMultiSelectFilter')(val);
                this.fullRolesList.push(roleObj);
            }
            this.fullRolesListCopy = angular.copy(this.fullRolesList);
        });
        if (this.savedFilters !== null) {
            this.selectedRoles = this.fullRolesList.filter(role => this.savedFilters.roleList.some(roleName => role.name == roleName));
            this.selectedRoles.forEach(role => role.ticked = true);
        }
        if (this.savedDisplayedRequisitionSelectedFilter.roleList.length !== 0 || this.requisitionsContainer.requisitionsQueryFilter.roleList.length !== 0) {
            this.displayRequisitionSelectedFilter.roleList = this.selectedRoles.map(role => role.name);
            this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
        }
    }
    _setRequisitionTypes() {
        this.requisitionTypes = [{ name: 'Shared', value: "SHARED" }];
        if (this.isStaffingCompany) {
            this.requisitionTypes.push({ name: 'External', value: "EXTERNAL" });
        }
        else {
            this.requisitionTypes.push({ name: 'Internal', value: 'INTERNAL' });
        }
        this.requisitionTypesCopy = angular.copy(this.requisitionTypes);
        if (this.savedFilters !== null) {
            this.selectedRequisitionTypes = this.requisitionTypes.filter(type => this.savedFilters.requisitionTypes.some(typeName => typeName == type.value));
            this.selectedRequisitionTypes.forEach(type => type.ticked = true);
        }
        if (this.savedDisplayedRequisitionSelectedFilter.requisitionTypes.length !== 0 || this.requisitionsContainer.requisitionsQueryFilter.requisitionTypes.length !== 0) {
            this.displayRequisitionSelectedFilter.requisitionTypes = this.selectedRequisitionTypes.map(type => type.name);
            this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
        }
    }
    _getRequisitionStatusTypes(successCallback) {
        this.loadingRequisitionStatuses = true;
        this.jobService.getAllStatusTypes((data) => {
            this._setRequisitionStatusTypes(data);
            this.loadingRequisitionStatuses = false;
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            this.loadingRequisitionStatuses = false;
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    _setRequisitionStatusTypes(statusTypes) {
        this.fullStatusList = statusTypes;
        this.fullStatusListCopy = angular.copy(this.fullStatusList);
        if (!_.isNull(this.$stateParams.requisitionStatesArray)) {
            for (let i = 0; i < this.fullStatusList.length; i++) {
                for (let j = 0; j < this.$stateParams.requisitionStatesArray.length; j++) {
                    if (this.fullStatusList[i].name == this.$stateParams.requisitionStatesArray[j]) {
                        this.fullStatusList[i]['ticked'] = true;
                        break;
                    }
                }
            }
        }
        if (this.savedFilters !== null) {
            this.selectedStatuses = this.fullStatusList.filter(status => this.savedFilters.requisitionStates.some(statusName => statusName == status.name.toUpperCase()));
            this.selectedStatuses.forEach(status => status.ticked = true);
        }
        if (this.savedDisplayedRequisitionSelectedFilter.requisitionStates.length !== 0 || this.requisitionsContainer.requisitionsQueryFilter.requisitionStates.length !== 0) {
            this.displayRequisitionSelectedFilter.requisitionStates = this.selectedStatuses.map(status => status.name);
            this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
        }
    }
    getRequisitionNumbers(searchReqText, successCallback) {
        this.loadingRequisitionNumbers = true;
        this.fullReqNumList = [];
        this.selectedRequisitionNumbers = [];
        if (searchReqText == "" || !angular.isDefined(searchReqText)) {
            searchReqText = "all";
        }
        this.searchReqText = searchReqText;
        let clientOrBuIds = this.selectedClients.map(clientOrBu => clientOrBu.id);
        let roleNames = this.selectedRoles.map(role => role.name);
        let reqNumberFilter = { clientOrBuIds: clientOrBuIds, roleNames: roleNames };
        this.jobService.searchByReqNum(this.userId, this.companyId, this.searchReqText, reqNumberFilter, (data) => {
            this._setRequisitionNumbers(data);
            if (searchReqText == "all") {
                this.fullReqNumListCopy = angular.copy(this.fullReqNumList);
            }
            this.loadingRequisitionNumbers = false;
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            this.loadingRequisitionNumbers = false;
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    _setRequisitionNumbers(requisitionNumbers) {
        let modifiedRequisitionNumbers = [];
        for (let i = 0; i < requisitionNumbers.length; i++) {
            let icon = requisitionNumbers[i].sharedRequisition ? '<i class="fas fa-share-alt"></i> ' : '<span class="pl-4"></span>';
            let obj = { name: requisitionNumbers[i].reqNumber, icon: icon };
            // if(!this._containsObject(obj, modifiedRequisitionNumbers, "name")) {
            obj.selectedDisplayName = this.$filter('displayOnMultiSelectFilter')(obj.name);
            modifiedRequisitionNumbers.push(obj);
            // }
        }
        for (let i = 0; i < modifiedRequisitionNumbers.length; i++) {
            for (let j = 0; j < this.selectedRequisitionNumbers.length; j++) {
                if (modifiedRequisitionNumbers[i].name == this.selectedRequisitionNumbers[j].name) {
                    modifiedRequisitionNumbers[i]['ticked'] = true;
                    break;
                }
            }
        }
        this.fullReqNumList = angular.copy(modifiedRequisitionNumbers);
        if (this.savedFilters !== null || (this.$stateParams.userParamsObject && this.$stateParams.userParamsObject.requisitionNumber)) {
            if (this.$stateParams.userParamsObject) {
                this.selectedRequisitionNumbers = this.fullReqNumList.filter(reqNumber => this.$stateParams.userParamsObject.requisitionNumber == reqNumber.name);
            }
            else {
                this.selectedRequisitionNumbers = this.fullReqNumList.filter(reqNumber => this.savedFilters.requisitionNums.some(num => num == reqNumber.name));
            }
            this.selectedRequisitionNumbers.forEach(num => num.ticked = true);
        }
        if (this.savedDisplayedRequisitionSelectedFilter.requisitionNums.length !== 0 || this.requisitionsContainer.requisitionsQueryFilter.requisitionNums.length !== 0 || (this.$stateParams.userParamsObject && this.$stateParams.userParamsObject.requisitionNumber)) {
            this.displayRequisitionSelectedFilter.requisitionNums = this.selectedRequisitionNumbers.map(req => req.name);
            this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
        }
    }
    _getRecruiters(successCallback) {
        this.fullRecruitersList = [];
        this.selectedRecruiters = [];
        let clientOrBUId = null;
        let requisitionId = null;
        this.loadingRecruiters = true;
        let clientOrBuIds = this.selectedClients.map(clientOrBu => clientOrBu.id);
        let requisitionNumbers = [];
        if (this.selectedClients.length > 0) {
            requisitionNumbers = this.fullReqNumList.map(reqNum => reqNum.name);
        }
        let isUploadOrEditReq = false;
        this.jobService.getAllRecruiters(this.$rootScope.userDetails, this.$rootScope.userDetails.company, clientOrBUId, requisitionId, clientOrBuIds, requisitionNumbers, isUploadOrEditReq, (data) => {
            var newRecruiterArray = [];
            var recruiters = data.recruiters;
            let hiringManagers = data.hiringManagers;
            let pocs = data.pocs;
            for (let i = 0; i < recruiters.length; i++) {
                var name;
                if (recruiters[i].lastName !== null) {
                    name = recruiters[i].firstName + " " + recruiters[i].lastName;
                }
                else {
                    name = recruiters[i].firstName;
                }
                let recObj = { "name": name, "id": recruiters[i].userId };
                if (!this._containsObject(recObj, newRecruiterArray, "name")) {
                    recObj.selectedDisplayName = name.length > 25 ? name.substring(0, 30) + "..." : name;
                    recObj.selectedDisplayName = recObj.selectedDisplayName + ` <sup>R</sup>`;
                    newRecruiterArray.push(recObj);
                }
            }
            hiringManagers.forEach(manager => {
                let name;
                if (manager.lastName !== null) {
                    name = manager.firstName + " " + manager.lastName;
                }
                else {
                    name = manager.firstName;
                }
                let recObj = { "name": name, "id": manager.userId };
                if (!this._containsObject(recObj, newRecruiterArray, "name")) {
                    recObj.selectedDisplayName = name.length > 25 ? name.substring(0, 30) + "..." : name;
                    recObj.selectedDisplayName = recObj.selectedDisplayName + ` <sup>H</sup>`;
                    newRecruiterArray.push(recObj);
                }
            });
            pocs.forEach(poc => {
                if (poc) {
                    let name;
                    if (poc.lastName !== null) {
                        name = poc.firstName + " " + poc.lastName;
                    }
                    else {
                        name = poc.firstName;
                    }
                    let recObj = { "name": name, "id": poc.userId };
                    if (!this._containsObject(recObj, newRecruiterArray, "name")) {
                        recObj.selectedDisplayName = name.length > 25 ? name.substring(0, 30) + "..." : name;
                        recObj.selectedDisplayName = recObj.selectedDisplayName + ` <sup>POC</sup>`;
                        newRecruiterArray.push(recObj);
                    }
                }
            });
            this.fullRecruitersList = angular.copy(newRecruiterArray);
            this.fullRecruitersListCopy = angular.copy(this.fullRecruitersList);
            if (this.savedFilters !== null) {
                this.selectedRecruiters = this.fullRecruitersList.filter(recruiter => this.savedFilters.recruiters.some(recruiterId => recruiterId == recruiter.id));
                this.selectedRecruiters.forEach(recruiter => recruiter.ticked = true);
            }
            if (this.savedDisplayedRequisitionSelectedFilter.recruiters.length !== 0 || this.requisitionsContainer.requisitionsQueryFilter.recruiters.length !== 0) {
                this.displayRequisitionSelectedFilter.recruiters = this.selectedRecruiters.map(recruiter => recruiter.name);
                this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
            }
            this.loadingRecruiters = false;
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            this.loadingRecruiters = false;
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    _getJobTypes(successCallback) {
        this.loadingJobTypes = true;
        this.jobService.getAllJobTypes((data) => {
            this.jobTypeList = data;
            this.jobTypeListCopy = angular.copy(this.jobTypeList);
            if (this.savedFilters !== null) {
                this.selectedJobTypes = this.jobTypeList.filter(jobType => this.savedFilters.jobTypes.some(jobTypeName => jobTypeName == jobType.value));
                this.selectedJobTypes.forEach(jobType => jobType.ticked = true);
            }
            if (this.savedDisplayedRequisitionSelectedFilter.jobTypes.length !== 0 || this.requisitionsContainer.requisitionsQueryFilter.jobTypes.length !== 0) {
                this.displayRequisitionSelectedFilter.jobTypes = this.selectedJobTypes.map(type => type.name);
                this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
            }
            this.loadingJobTypes = false;
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            this.loadingJobTypes = false;
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    _getWorkLocations(successCallback) {
        this.loadingWorkLocations = true;
        this.jobService.getWorkLocations((data) => {
            this.workLocationList = data;
            this.workLocationList = this.workLocationList.filter((location) => location.id != 'NO_WORK_LOCATION');
            this.workLocationListCopy = angular.copy(this.workLocationList);
            if (this.savedFilters !== null && this.savedFilters.workLocationIds) {
                this.selectedWorkLocations = this.workLocationList.filter(workLocation => this.savedFilters.workLocationIds.some(id => id === workLocation.id));
                this.selectedWorkLocations.forEach(workLocation => workLocation.ticked = true);
            }
            if (this.savedDisplayedRequisitionSelectedFilter.workLocationIds.length !== 0 || this.requisitionsContainer.requisitionsQueryFilter.workLocationIds.length !== 0) {
                this.displayRequisitionSelectedFilter.workLocationIds = this.selectedWorkLocations.map(workLocation => workLocation.name);
                this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
            }
            this.loadingWorkLocations = false;
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            this.loadingWorkLocations = false;
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    _containsObject(obj, list, key) {
        for (var index in list) {
            var currentObject = list[index];
            for (var prop in currentObject) {
                if (prop === key && currentObject.hasOwnProperty(prop)
                    && currentObject[prop] === obj[prop]) {
                    return true;
                }
            }
        }
        return false;
    }
    _getRequisitionActivityTypes() {
        this.jobService.getActivityTypes((data) => {
            this.fullActivityList = data;
            this.activityMap = [];
            angular.forEach(data, (val, key) => {
                this.activityMap[val.value] = val.name;
            });
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    _getSalaryDurationOptions(successCallback) {
        this.jobService.getSalaryDurationOptions((data) => {
            this.salaryDurationOptions = data;
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            //do nothing
        });
    }
    queryRequisitions() {
        this.requisitionsContainer.loadingSearchButton = true;
        // clear any existing query requests
        // check for an existing promise and see if it has not been fulfilled yet. If it has not been fulfilled yet, cancel the promise.
        // if(!(_.isNull(this.requisitionsContainer.currentPromise) || this.requisitionsContainer.currentPromise === undefined) && this.requisitionsContainer.currentPromise.$$state.status == 0) {
        if (!(_.isNull(this.requisitionsContainer.currentPromise) || this.requisitionsContainer.currentPromise === undefined)) {
            this.genericService.cancelRequest(this.requisitionsContainer.currentPromise);
        }
        // reset the initial value of requisitions exist flag to true
        this.requisitionsContainer.requisitionsExistFlag = true;
        // reset the page number to 1 as this is a new query
        this.requisitionsContainer.requisitionsQueryFilter.pageNum = 1;
        this.currentRequisitionPage = 1;
        // clear the existing requisitions
        this.requisitionsContainer.requisitions = [];
        this.requisitionsContainer.disableInfiniteScroll = false;
        // Hide Display Filter
        if (this.displayRequisitionFilterItemsSelected.length === 0) {
            this.displayFilterFlag = false;
            this.displayRequisitionSelectedFilter.showDisplayFilterIconFlag = true;
        }
        // wait for the cancel promise to be fulfilled, if it was called.
        this.$timeout(() => {
            this.stateManagementStorageService.setScreenState(`requisitionsScreen-${this.userId}`, this.requisitionsContainer.requisitionsQueryFilter);
            // Display Selected Filter
            this.stateManagementStorageService.setScreenState(`requisitionsScreen-displayFilter-${this.userId}`, this.displayRequisitionSelectedFilter);
            this.isFiltersChanged = false;
            if (this.isRowViewActive) {
                this.requisitionsContainer.getNextPage(this.currentRequisitionPage);
            }
            else {
                this.requisitionsContainer.getNext();
            }
        }, 200);
    }
    _setRecruiters(recruiters) {
        let newRecruiterArray = [];
        if (recruiters.length == 0) {
            this.selectedRecruiters = [];
            this.requisitionsContainer.requisitionsQueryFilter.recruiters = [];
        }
        let $selectedRecruiters = angular.copy(this.selectedRecruiters);
        for (let i = 0; i < recruiters.length; i++) {
            var name;
            if (recruiters[i].lastname !== null) {
                name = recruiters[i].firstname + " " + recruiters[i].lastname;
            }
            else {
                name = recruiters[i].firstname;
            }
            var recObj = { "name": name, "id": recruiters[i].id };
            if (!this._containsObject(recObj, newRecruiterArray, "name")) {
                recObj.selectedDisplayName = this.$filter('displayOnMultiSelectFilter')(name);
                newRecruiterArray.push(recObj);
            }
        }
        for (let i = 0; i < newRecruiterArray.length; i++) {
            for (let j = 0; j < $selectedRecruiters.length; j++) {
                if (newRecruiterArray[i].id == $selectedRecruiters[j].id) {
                    newRecruiterArray[i]['ticked'] = true;
                    break;
                }
            }
        }
        this.fullRecruitersList = angular.copy(newRecruiterArray);
    }
    _setClients(clients) {
        let newClientArray = [];
        if (clients.length == 0) {
            this.selectedClients = [];
            this.requisitionsContainer.requisitionsQueryFilter.clientOrBU = [];
        }
        this.selectedClients = angular.copy(this.selectedClients);
        for (let i = 0; i < clients.length; i++) {
            if (angular.isDefined(clients[i]) && clients[i] != null && angular.isDefined(clients[i].id)) {
                let recObj = { "name": clients[i].name, "id": clients[i].id };
                if (!this._containsObject(recObj, newClientArray, "name")) {
                    newClientArray.push(recObj);
                }
            }
        }
        for (let i = 0; i < newClientArray.length; i++) {
            for (let j = 0; j < $selectedClients.length; j++) {
                if (newClientArray[i].id == $selectedClients[j].id) {
                    newClientArray[i]['ticked'] = true;
                    break;
                }
            }
        }
        this.fullClientsList = angular.copy(newClientArray);
    }
    toggleSearchByText() {
        this.hideSearchByText = !this.hideSearchByText;
    }
    onClientClick() {
        this.isFiltersChanged = true;
        this._getRoles("all");
        this.getRequisitionNumbers("all", () => {
            this._getRecruiters(() => {
                this.requisitionsContainer.requisitionsQueryFilter.clientOrBU = this.selectedClients.map(clientOrBu => clientOrBu.id);
                this.requisitionsContainer.requisitionsQueryFilter.roleList = [];
                this.requisitionsContainer.requisitionsQueryFilter.requisitionNums = [];
                this.requisitionsContainer.requisitionsQueryFilter.recruiters = [];
                this.displayRequisitionSelectedFilter.clientOrBU = this.selectedClients.map((val, index) => {
                    if (val.companyType === 'Corporation') {
                        return val.shortName;
                    }
                    else {
                        return val.name;
                    }
                });
                this.displayRequisitionSelectedFilter.roleList = [];
                this.displayRequisitionSelectedFilter.recruiters = [];
                this.displayRequisitionSelectedFilter.requisitionNums = [];
                this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
            });
        });
    }
    onRoleClick() {
        this.isFiltersChanged = true;
        this.getRequisitionNumbers("all", () => {
            this._getRecruiters(() => {
                this.requisitionsContainer.requisitionsQueryFilter.roleList = this.selectedRoles.map(role => role.name);
                this.requisitionsContainer.requisitionsQueryFilter.requisitionNums = [];
                this.requisitionsContainer.requisitionsQueryFilter.recruiters = [];
                this.displayRequisitionSelectedFilter.roleList = this.requisitionsContainer.requisitionsQueryFilter.roleList;
                this.displayRequisitionSelectedFilter.recruiters = [];
                this.displayRequisitionSelectedFilter.requisitionNums = [];
                this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
            });
        });
    }
    onRequisitionTypeClick() {
        this.isFiltersChanged = true;
        this.requisitionsContainer.requisitionsQueryFilter.requisitionTypes = this.selectedRequisitionTypes.map(type => type.value);
        this.displayRequisitionSelectedFilter.requisitionTypes = [];
        this.displayRequisitionSelectedFilter.requisitionTypes = this.selectedRequisitionTypes.map(type => type.name);
        this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
    }
    onRequisitionStatusClick() {
        this.isFiltersChanged = true;
        this.requisitionsContainer.requisitionsQueryFilter.requisitionStates = this.selectedStatuses.map(status => angular.uppercase(status.name));
        this.displayRequisitionSelectedFilter.requisitionStates = this.selectedStatuses.map(status => status.name);
        this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
    }
    onRequisitionNumberClick() {
        this.isFiltersChanged = true;
        this.requisitionsContainer.requisitionsQueryFilter.requisitionNums = this.selectedRequisitionNumbers.map(req => req.name);
        this.displayRequisitionSelectedFilter.requisitionNums = this.requisitionsContainer.requisitionsQueryFilter.requisitionNums;
        this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
    }
    onRecruiterClick() {
        this.isFiltersChanged = true;
        this.requisitionsContainer.requisitionsQueryFilter.recruiters = this.selectedRecruiters.map(recruiter => recruiter.id);
        this.displayRequisitionSelectedFilter.recruiters = this.selectedRecruiters.map(recruiter => recruiter.name);
        this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
    }
    onJobTypeClick() {
        this.isFiltersChanged = true;
        this.requisitionsContainer.requisitionsQueryFilter.jobTypes = this.selectedJobTypes.map(type => type.value);
        this.displayRequisitionSelectedFilter.jobTypes = this.selectedJobTypes.map(type => type.name);
        this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
    }
    onWorkLocationClick() {
        this.isFiltersChanged = true;
        this.requisitionsContainer.requisitionsQueryFilter.workLocationIds = this.selectedWorkLocations.map(workLocation => workLocation.id);
        this.displayRequisitionSelectedFilter.workLocationIds = this.selectedWorkLocations.map(workLocation => workLocation.name);
        this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
    }
    _setShowDisplayFilterIcon(boolean) {
        let savedDisplayedRequisitionSelectedFilter = this.stateManagementStorageService.getScreenState(`requisitionsScreen-displayFilter-${this.userId}`);
        savedDisplayedRequisitionSelectedFilter.showDisplayFilterIconFlag = boolean;
        this.stateManagementStorageService.setScreenState(`requisitionsScreen-displayFilter-${this.userId}`, savedDisplayedRequisitionSelectedFilter);
        if (this.displayRequisitionSelectedFilter.showDisplayFilterIconFlag !== boolean) {
            this.displayRequisitionSelectedFilter.showDisplayFilterIconFlag = boolean;
        }
    }
    displaySelectedFilterToggle() {
        this.showDisplaySelectedFilterPanel = true;
        if (this.displayFilterFlag) {
            $("#display-selected-filter-panel").animate({
                height: 'toggle'
            });
            this.displayRequisitionSelectedFilter.showDisplayFilterIconFlag = !this.displayRequisitionSelectedFilter.showDisplayFilterIconFlag;
        }
        // Set Display Filter Collapse and Expand Panel
        this._setShowDisplayFilterIcon(this.displayRequisitionSelectedFilter.showDisplayFilterIconFlag);
    }
    isFilterValueArray(value) {
        if (Array.isArray(value)) {
            return true;
        }
        else {
            return false;
        }
    }
    addToDisplayFilters(event) {
        switch (event) {
            case 'search':
                this.displayRequisitionSelectedFilter.searchString = this.requisitionsContainer.requisitionsQueryFilter.searchText;
                this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
                break;
            default:
                break;
        }
    }
    _setObjectVariableName(currentObject) {
        let selectedFilterVariableNameObj = {
            clientOrBU: "Belongs To", roleList: "Role", requisitionTypes: "Requisition Type",
            requisitionStates: "Requisition Status", requisitionNums: "Requisition Number", recruiters: "Recruiter/Hiring Manager",
            jobTypes: "Job Type", workLocationIds: "Work Location", selectedFilterSort: "Sort By", searchString: "Search"
        };
        for (var key in selectedFilterVariableNameObj) {
            if (selectedFilterVariableNameObj.hasOwnProperty(key)) {
                var obj = selectedFilterVariableNameObj[key];
                if (key == currentObject.variable) {
                    this.displaySelectedFilterObj.variable = obj;
                }
            }
        }
    }
    setRequisitionDisplayedFilterItemSelected(itemsSelected) {
        this.emptySelectedFilter = false;
        for (var key in itemsSelected) {
            if (itemsSelected.hasOwnProperty(key)) {
                var obj = itemsSelected[key];
                if (obj.length > 0) {
                    this.displayFilterFlag = true;
                    this.displaySelectedFilterObj = {};
                    if (this.displayRequisitionFilterItemsSelected.length !== 0) {
                        this.displayRequisitionFilterItemsSelected.forEach((filterItem) => {
                            if (filterItem.filter == key) {
                                if (filterItem.setSelectedFilterLimit == 5) {
                                    this.displaySelectedFilterObj = { filter: key, variable: key, value: obj, setSelectedFilterLimit: 5, expandSelectedFilter: false };
                                }
                                else {
                                    this.displaySelectedFilterObj = { filter: key, variable: key, value: obj, setSelectedFilterLimit: obj.length, expandSelectedFilter: filterItem.expandSelectedFilter };
                                }
                            }
                        });
                    }
                    if (this.displayRequisitionFilterItemsSelected.length == 0 || Object.keys(this.displaySelectedFilterObj).length == 0) {
                        this.displaySelectedFilterObj = { filter: key, variable: key, value: obj, setSelectedFilterLimit: 5, expandSelectedFilter: false };
                    }
                    this._setObjectVariableName(this.displaySelectedFilterObj);
                    if (this.displayRequisitionFilterItemsSelected.length > 0) {
                        this.displayRequisitionFilterItemsSelected = this.displayRequisitionFilterItemsSelected.filter(item => item.variable !== this.displaySelectedFilterObj.variable);
                    }
                    this.displayRequisitionFilterItemsSelected.push(this.displaySelectedFilterObj);
                }
                else {
                    if (this.displayRequisitionFilterItemsSelected.length > 0) {
                        this.displayRequisitionFilterItemsSelected = this.displayRequisitionFilterItemsSelected.filter(item => item.filter !== key);
                    }
                }
            }
        }
        if (this.displayRequisitionFilterItemsSelected.length === 0) {
            if (!this.requisitionsContainer.isFilterOn) {
                this.displayFilterFlag = false;
                this._setShowDisplayFilterIcon(true);
            }
            else {
                this.emptySelectedFilter = true;
            }
        }
    }
    _setOpenGlobalFilter() {
        if (!this.showFiltersPanel) {
            $("#search-panel").animate({
                height: 'toggle'
            });
            this.showFiltersPanel = true;
        }
    }
    _deleteSelectedItem(currentObject, deletedItem) {
        switch (currentObject.variable) {
            case 'searchString':
                this.requisitionsContainer.requisitionsQueryFilter.searchText = '';
                this.displayRequisitionSelectedFilter.searchString = '';
                this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
                break;
            case 'clientOrBU':
                this.fullClientsList.forEach((client, index) => {
                    if (client.name === deletedItem) {
                        client.ticked = false;
                        this.selectedClients = this.selectedClients.filter(item => item.name !== deletedItem);
                    }
                    else if (client.shortName === deletedItem) {
                        client.ticked = false;
                        this.selectedClients = this.selectedClients.filter(item => item.name !== deletedItem);
                    }
                });
                this.onClientClick();
                break;
            case 'roleList':
                this.fullRolesList.forEach((role, index) => {
                    if (role.name === deletedItem) {
                        role.ticked = false;
                        this.selectedRoles = this.selectedRoles.filter(item => item.name !== deletedItem);
                    }
                });
                this.onRoleClick();
                break;
            case 'requisitionTypes':
                this.requisitionTypes.forEach((reqType, index) => {
                    if (reqType.name === deletedItem) {
                        reqType.ticked = false;
                        this.selectedRequisitionTypes = this.selectedRequisitionTypes.filter(item => item.name !== deletedItem);
                    }
                });
                this.onRequisitionTypeClick();
                break;
            case 'requisitionStates':
                this.fullStatusList.forEach((reqStatus, index) => {
                    if (reqStatus.name === deletedItem) {
                        reqStatus.ticked = false;
                        this.selectedStatuses = this.selectedStatuses.filter(item => item.name !== deletedItem);
                    }
                });
                this.onRequisitionStatusClick();
                break;
            case 'requisitionNums':
                this.fullReqNumList.forEach((reqNum, index) => {
                    if (reqNum.name === deletedItem) {
                        reqNum.ticked = false;
                        this.selectedRequisitionNumbers = this.selectedRequisitionNumbers.filter(item => item.name !== deletedItem);
                    }
                });
                this.onRequisitionNumberClick();
                break;
            case 'recruiters':
                this.fullRecruitersList.forEach((recruiter, index) => {
                    if (recruiter.name === deletedItem) {
                        recruiter.ticked = false;
                        this.selectedRecruiters = this.selectedRecruiters.filter(item => item.name !== deletedItem);
                    }
                });
                this.onRecruiterClick();
                break;
            case 'jobTypes':
                this.jobTypeList.forEach((jobType, index) => {
                    if (jobType.name === deletedItem) {
                        jobType.ticked = false;
                        this.selectedJobTypes = this.selectedJobTypes.filter(item => item.name !== deletedItem);
                    }
                });
                this.onJobTypeClick();
                break;
            case 'workLocationIds':
                this.workLocationList.forEach((location, index) => {
                    if (location.name === deletedItem) {
                        location.ticked = false;
                        this.selectedWorkLocations = this.selectedWorkLocations.filter(item => item.name !== deletedItem);
                    }
                });
                this.onWorkLocationClick();
                break;
            case 'selectedFilterSort':
                this.sortRequisitions('', 'Please Select', '');
                break;
            default:
                break;
        }
    }
    deleteSelectedFilterItem(deletedItem) {
        this._setOpenGlobalFilter();
        for (var key in this.displayRequisitionSelectedFilter) {
            if (this.displayRequisitionSelectedFilter.hasOwnProperty(key)) {
                var obj = this.displayRequisitionSelectedFilter[key];
                if (Array.isArray(obj)) {
                    if (obj.includes(deletedItem)) {
                        this.deleteSelectedFilter = {};
                        this.deleteSelectedFilter = { variable: key, value: obj };
                        this._deleteSelectedItem(this.deleteSelectedFilter, deletedItem);
                    }
                }
                else {
                    if (obj == deletedItem) {
                        this.deleteSelectedFilter = {};
                        this.deleteSelectedFilter = { variable: key, value: obj };
                        this._deleteSelectedItem(this.deleteSelectedFilter, deletedItem);
                    }
                }
            }
        }
    }
    setCandidate(candidate, candidateFlag) {
        this.requisitionSPOC.candidateId = candidate[0].id;
        if (candidateFlag) {
            this.requisitionSPOC.openingNumber = candidate[0].requisitionOpeningNumber;
        }
    }
    //            this.searchRequisitions =  (requisition) {
    //                return (angular.lowercase(requisition.companyName).indexOf(angular.lowercase(this.searchTerm) || '') !== -1 ||
    //                    angular.lowercase(requisition.requisitionRole).indexOf(angular.lowercase(this.searchTerm) || '') !== -1);
    //            };
    deleteRequisition(requisition) {
        if (this.isRowViewActive) {
            let rowViewRequisitionIndex = _.findIndex(this.requisitionsContainer.requisitionsPerPage, { 'requisitionNumber': requisition.requisitionNumber });
            this.requisitionsContainer.requisitionsPerPage.splice(rowViewRequisitionIndex, 1);
        }
        else {
            let requisitionIndex = _.findIndex(this.requisitionsContainer.requisitions, { 'requisitionNumber': requisition.requisitionNumber });
            this.requisitionsContainer.requisitions.splice(requisitionIndex, 1);
        }
        this.requisitionsContainer.requisitionCount = this.requisitionsContainer.requisitionCount - 1;
    }
    copyRequisition() {
        this.$state.reload();
    }
    selectRemoveAll(label, type) {
        this._setFiltersAndFetchJobs(label, type);
    }
    _setFiltersAndFetchJobs(label, type) {
        if (type == 'selectAll') {
            if (label === this.MESSAGECONSTANTS.LABLES.CLIENT || label === this.MESSAGECONSTANTS.LABLES.BU) {
                this.selectedClients = [...this.fullClientsList];
                this.onClientClick();
            }
            else if (label === this.MESSAGECONSTANTS.LABLES.USER_MANAGEMENT.ROLE) {
                this.selectedRoles = [...this.fullRolesList];
                this.onRoleClick();
            }
            else if (label === this.MESSAGECONSTANTS.LABLES.REQUISITION_STATUS) {
                this.selectedStatuses = [...this.fullStatusList];
                this.onRequisitionStatusClick();
            }
            else if (label === this.MESSAGECONSTANTS.LABLES.RECRUITER) {
                this.selectedRecruiters = [...this.fullRecruitersList];
                this.onRecruiterClick();
            }
            else if (label === this.MESSAGECONSTANTS.LABLES.REQ_NUMBER) {
                this.selectedRequisitionNumbers = [...this.fullReqNumList];
                this.onRequisitionNumberClick();
            }
            else if (label === 'requisitionType') {
                this.selectedRequisitionTypes = [...this.requisitionTypes];
                this.onRequisitionTypeClick();
            }
            else if (label == 'Job Type') {
                this.selectedJobTypes = [...this.jobTypeList];
                this.onJobTypeClick();
            }
            else if (label == 'Work Location') {
                this.selectedWorkLocations = [...this.workLocationList];
                this.onWorkLocationClick();
            }
        }
        else {
            if (label === this.MESSAGECONSTANTS.LABLES.CLIENT || label === this.MESSAGECONSTANTS.LABLES.BU) {
                this.fullClientsList.forEach(clientOrBU => clientOrBU.ticked = false);
                this.selectedClients = [];
                this.onClientClick();
            }
            else if (label === this.MESSAGECONSTANTS.LABLES.USER_MANAGEMENT.ROLE) {
                this.fullRolesList.map(role => role.ticked = false);
                this.selectedRoles = [];
                this.onRoleClick();
            }
            else if (label === this.MESSAGECONSTANTS.LABLES.REQUISITION_STATUS) {
                this.fullStatusList.map(status => status.ticked = false);
                this.selectedStatuses = [];
                this.onRequisitionStatusClick();
            }
            else if (label === this.MESSAGECONSTANTS.LABLES.RECRUITER) {
                this.fullRecruitersList.forEach(recruiter => recruiter.ticked = false);
                this.selectedRecruiters = [];
                this.onRecruiterClick();
            }
            else if (label === this.MESSAGECONSTANTS.LABLES.REQ_NUMBER) {
                this.fullReqNumList.map(num => num.ticked = false);
                this.selectedRequisitionNumbers = [];
                this.onRequisitionNumberClick();
            }
            else if (label === 'requisitionType') {
                this.requisitionTypes.forEach(type => type.ticked = false);
                this.selectedRequisitionTypes = [];
                this.onRequisitionTypeClick();
            }
            else if (label == 'Job Type') {
                this.jobTypeList.map(type => type.ticked = false);
                this.selectedJobTypes = [];
                this.onJobTypeClick();
            }
            else if (label == 'Work Location') {
                this.workLocationList.map(workLocation => workLocation.ticked = false);
                this.selectedWorkLocations = [];
                this.onWorkLocationClick();
            }
        }
    }
    sortRequisitions(sortColumn, selectedSort, selectedSortDir) {
        this.isFiltersChanged = true;
        this.selectedSort = selectedSort;
        this.selectedSortDir = selectedSortDir;
        this.requisitionsContainer.requisitionsQueryFilter.sortColumn = "";
        this.requisitionsContainer.requisitionsQueryFilter.sortDirection = "";
        if (angular.isDefined(sortColumn) && sortColumn != "") {
            var array = sortColumn.split(" ");
            this.requisitionsContainer.requisitionsQueryFilter.sortColumn = array[0];
            this.requisitionsContainer.requisitionsQueryFilter.sortDirection = array[1];
        }
        this.displayRequisitionSelectedFilter.selectedFilterSort = "";
        if (selectedSort != "Please Select") {
            this.displayRequisitionSelectedFilter.selectedFilterSort = selectedSort + " " + "(" + selectedSortDir + ")";
        }
        this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
    }
    sortByDate(daterange) {
        this.isFiltersChanged = true;
        this.requisitionsContainer.requisitionsQueryFilter.fromDate = "";
        this.requisitionsContainer.requisitionsQueryFilter.toDate = "";
        this.selectedDateRangeCopy = angular.copy(this.selectedDateRange);
        if (angular.isDefined(this.selectedDateRangeCopy) && this.selectedDateRangeCopy !== "") {
            let array = this.selectedDateRangeCopy.split("-");
            this.requisitionsContainer.requisitionsQueryFilter.fromDate = array[0];
            this.requisitionsContainer.requisitionsQueryFilter.toDate = array[1];
        }
        else {
            this.selectedDateRange = "";
        }
    }
    resetFilterData() {
        this.isFiltersChanged = true;
        this.requisitionsContainer.requisitionsQueryFilter = angular.copy(new RequisitionsQueryFilter(this.companyId));
        this.selectedSort = "Please Select";
        this.fullClientsList = angular.copy(this.fullClientsListCopy);
        this.fullRecruitersList = angular.copy(this.fullRecruitersListCopy);
        this.fullRolesList = angular.copy(this.fullRolesListCopy);
        this.fullStatusList = angular.copy(this.fullStatusListCopy);
        this.jobTypeList = angular.copy(this.jobTypeListCopy);
        this.workLocationList = angular.copy(this.workLocationListCopy);
        this.fullReqNumList = angular.copy(this.fullReqNumListCopy);
        this.requisitionTypes = angular.copy(this.requisitionTypes);
        angular.forEach(this.fullClientsList, (val, key) => {
            val.ticked = false;
        });
        angular.forEach(this.fullRecruitersList, (val, key) => {
            val.ticked = false;
        });
        angular.forEach(this.fullRolesList, (val, key) => {
            val.ticked = false;
        });
        angular.forEach(this.fullStatusList, (val, key) => {
            val.ticked = false;
        });
        angular.forEach(this.jobTypeList, (val, key) => {
            val.ticked = false;
        });
        angular.forEach(this.workLocationList, (val, key) => {
            val.ticked = false;
        });
        angular.forEach(this.fullReqNumList, (val, key) => {
            val.ticked = false;
        });
        angular.forEach(this.requisitionTypes, (val, key) => {
            val.ticked = false;
        });
        this.displayRequisitionSelectedFilter = new requisitionDisplaySelectedFilter();
        let savedDisplayedRequisitionSelectedFilter = this.stateManagementStorageService.getScreenState(`requisitionsScreen-displayFilter-${this.userId}`);
        this.displayRequisitionSelectedFilter.showDisplayFilterIconFlag = savedDisplayedRequisitionSelectedFilter.showDisplayFilterIconFlag;
        this.setRequisitionDisplayedFilterItemSelected(this.displayRequisitionSelectedFilter);
    }
    uploadRequisition() {
        if (this.isStaffingCompany && (!this.fullClientsList || this.fullClientsList.length == 0)) {
            let message = "Please setup atleast one client in 'Manage Client' before creating a Requisition.";
            this.alertsAndNotificationsService.showCustomConfirm("Add Client", "Cancel", "No Clients", message, "warning", 'medium', () => {
                this.$state.go('missioncontrol.clientsOrBus', { reload: true });
            }, () => { });
        }
        else {
            this.$state.go('missioncontrol.uploadreq', { jobState: 'Draft' });
        }
    }
    _initJquery() {
        // $('input[name="daterange"]').daterangepicker({
        //     locale: {
        //         cancelLabel: 'Clear'
        //     },
        //     ranges: {
        //         'Today': [this.moment(), this.moment()],
        //         'Yesterday': [this.moment().subtract(1, 'days'), this.moment().subtract(1, 'days')],
        //         'This Week': [this.moment().startOf('week'), this.moment().endOf('week')],
        //         'Last Week': [this.moment().subtract(1, 'week').startOf('week'), this.moment().subtract(1, 'week').endOf('week')],
        //         'This Month': [this.moment().startOf('month'), this.moment().endOf('month')],
        //         'Last Month': [this.moment().subtract(1, 'month').startOf('month'), this.moment().subtract(1, 'month').endOf('month')],
        //         'This Quarter': [this.moment().startOf('quarter'), this.moment().endOf('quarter')],
        //         'Last Quarter': [this.moment().subtract(1, 'quarter').startOf('quarter'), this.moment().subtract(1, 'quarter').endOf('quarter')],
        //         'Past 6 Weeks': [this.moment().subtract(5, 'week').startOf('week'), this.moment().endOf('week')],
        //         'Past 6 Months': [this.moment().subtract(5, 'month').startOf('month'), this.moment().endOf('month')],
        //         'Past 6 Quarter': [this.moment().subtract(5, 'quarter').startOf('quarter'), this.moment().endOf('quarter')],
        //     }
        // });
        // $('input[name="daterange"]').on('cancel.daterangepicker', (ev, picker) => {
        //     $(this).val("");
        //     this.requisitionsContainer.requisitionsQueryFilter.fromDate = "";
        //     this.requisitionsContainer.requisitionsQueryFilter.toDate = "";
        //     this.filterJobs(() => {
        //     });
        // });
        //Implementaion of filters
        $(document).ready(() => {
            $("#search-panel").hide();
            $(document).off("click", "#open-filter").on("click", "#open-filter", () => {
                $("#search-panel").animate({
                    height: 'toggle'
                });
                this.showFiltersPanel = !this.showFiltersPanel;
            });
        });
        // $('html').on('mouseup', (e) => {
        //     if(!$(e.target).closest('.popover').length) {
        //         $('.popover').each(() => {
        //             $(this.previousSibling).popover('hide');
        //         });
        //     }
        // });
    }
    onGlobalFilterChange(event) {
        this.isFiltersChanged = true;
        if (!this.showFiltersPanel) {
            $("#search-panel").animate({
                height: 'toggle'
            });
            this.showFiltersPanel = true;
        }
        if (this._onEnterKeyPress(event)) {
            this.queryRequisitions();
        }
    }
    _onEnterKeyPress(event) {
        return event && event.keyCode == 13;
    }
}
RequisitionsPageController.$inject = ['$rootScope', '$state', '$timeout', '$filter', 'moment', 'StorageService', 'requisitionService', 'jobService', 'companyService', 'stateManagementStorageService', 'genericService', 'alertsAndNotificationsService', 'sharedAjsService', 'REQUISITIONSCONSTANTS', 'MESSAGECONSTANTS'];
// import * as TEMPLATE from './requisitions-page.html';
import * as TEMPLATE from 'raw-loader!./requisitions-page.html';
export const RequisitionsPageComponent = {
    selector: 'requisitionsPage',
    component: {
        bindings: {
            $transition$: '<'
        },
        // templateUrl: 'app/partials/missioncontrol/requisitions/requisitions-page.html',
        template: TEMPLATE.default,
        controller: RequisitionsPageController
    }
};
//# sourceMappingURL=requisitions-page.component.js.map